import { render, staticRenderFns } from "./BcCalendar.vue?vue&type=template&id=35b22537"
import script from "./BcCalendar.vue?vue&type=script&lang=js"
export * from "./BcCalendar.vue?vue&type=script&lang=js"
import style0 from "./BcCalendar.vue?vue&type=style&index=0&id=35b22537&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports